import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function SentimentInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Text column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Model</FieldLabel>
      <Select value={c.model || 'vader'} onChange={(v) => u({ model: v })}
        options={[
          { value: 'vader', label: 'VADER (rule-based)' },
          { value: 'distilbert', label: 'DistilBERT' },
          { value: 'claude', label: 'Claude Haiku' },
        ]} />
      <FieldLabel>Output columns</FieldLabel>
      <div style={{ display: 'flex', gap: 6 }}>
        <TextInput mono value={c.scoreCol ?? 'sentiment_score'} onChange={(v) => u({ scoreCol: v })} />
        <TextInput mono value={c.labelCol ?? 'sentiment_label'} onChange={(v) => u({ labelCol: v })} />
      </div>
      <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
    </div>
  );
}
